import React from 'react';

export const PhoneContact = () => {
    return (
        <a href="tel:+91 9167332984" target="_blank">
            <div className="mobile-raw">
            </div>
        </a>
    )
}